import { PaletteMode, createTheme } from "@mui/material";

import { darkModePalette, lightModePalette } from "./palette";
import { typography } from "./typography";
import { spacing } from "./spacing";
import { breakpoints } from "./breakpoints";
import { transitions } from "./transitions";
import { components } from "./components";

export const theme = (mode?: PaletteMode) => {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light" ? lightModePalette : darkModePalette),
    },
    shape: {
      borderRadius: 12,
    },
    typography,
    spacing,
    breakpoints,
    transitions,
    components,
  });
};
